"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Separator = exports.CloseButton = exports.Title = exports.Drawer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const drawer_1 = __importDefault(require("@kyruus/drawer"));
const button_1 = __importDefault(require("@kyruus/button"));
exports.Drawer = (0, styled_1.default)(drawer_1.default) `
  & .MuiDrawer-paper {
    display: grid;
    grid-template-areas: 'title close' 'separator separator' 'content content';
    grid-auto-columns: 1fr auto;
    grid-auto-rows: auto calc(1px + ${(0, ui_theme_1.fromTheme)('spacing_medium')}) 1fr;
    border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    width: 100%;
    overflow: hidden;
  }
`;
exports.Title = (0, styled_1.default)('h1') `
  grid-area: title;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin: 0;
`;
exports.CloseButton = (0, styled_1.default)(button_1.default) `
  grid-area: close;
`;
exports.Separator = (0, styled_1.default)('hr') `
  grid-area: separator;
  border: none;
  height: 1px;
  background-color: ${(0, ui_theme_1.fromTheme)('color_border')};
  width: 100%;
  margin-top: 0;
`;
exports.Content = (0, styled_1.default)('div') `
  grid-area: content;
  width: 100%;
  overflow: auto;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  & > h2 {
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
    position: sticky;
    left: 0;
    margin-top: 0;
  }
  & > div[role='tablist'] {
    position: sticky;
    left: 0;
  }
  &&& > div[role='tabpanel'] div[role='button'] {
    top: -${(0, ui_theme_1.fromTheme)('spacing_medium')};
    left: 0;
  }
`;
//# sourceMappingURL=PracticeGuideDrawer.styles.js.map